module.exports = __webpack_public_path__ + "img/germany-tuberculosis-female.c3eaed7b.png";